<template>
  <div class="container">
    <div class="rl row"><a @click="$router.push('/')">首页</a><a @click="$router.push(s.link)" v-for="(s,i)  in rd" :key="i">{{s.title}}</a></div>
  </div>
</template>

<script>
export default {
  name: "routerlink",
  props:["rd"],
  components: {},
  created() {
      // console.log(this.$props.rd);
  },

};
</script>
<style lang="less" >

.rl {
  height: 80px !important;
  line-height: 80px !important;
  box-sizing: border-box;
  a {
    padding:0 70px 0 50px;
    width: 80px;
    font-size: 16px;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    background-image: url("../../assets/img/jt.png");
    background-position: center right;
    background-repeat: no-repeat;
    background-size: contain;
    &:last-child{
        background:none;
    }
    &:first-child{
         padding:0 70px 0 0px;
    }
  }
}
@media (max-width:768px) {
    .rl {
  height: 16px !important;
  line-height: 16px !important;
  box-sizing: border-box;
  margin:20px;
  a {
    padding:0 20px 0 !important;
    width: 80px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    background-image: url("../../assets/img/jt.png");
    background-position: center right;
    background-repeat: no-repeat;
    background-size: 6px 10px;
    &:last-child{
        background:none;
    }
    &:first-child{
        padding:0 30px 0  0!important;
    }
  }
}
}
</style>